module.exports = __webpack_public_path__ + "prod/1.42.2/img/yycj_three.b654e32f.png";